import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpRegularesComponent } from './regulares/help-regulares.component';
import { InitPrimengModule } from 'src/app/core/modules/primeng/init-primeng.module';


const compo = [
  HelpRegularesComponent
]
@NgModule({
  declarations: [
    ...compo
  ],
  imports: [
    CommonModule,
    InitPrimengModule
  ],
  exports: [
    ...compo
  ]
})
export class HelpsModule { }
